/**
 * @file index.tsx
 *
 * @fileoverview Scrolls to the first error once the form is submitted inside
 * a form component.
 */
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

export const ErrorFocus = () => {
  const {
    formState: { isSubmitting, isValidating, errors },
  } = useFormContext();

  useEffect(() => {
    const keys = Object.keys(errors);

    if (keys.length > 0 && isSubmitting && !isValidating) {
      const errorElement = document.getElementById(keys[0]);

      if (errorElement) {
        errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }
  }, [isSubmitting, isValidating, errors]);

  return null;
};

export default ErrorFocus;
